import DownloadSiteWhatsapp from "./components/ShowWhatsAppButton";

const AppComponents = () => {
  return (
    <>
      <div className="fixed bottom-8 right-2 flex flex-col items-center gap-6 z-50">
        <DownloadSiteWhatsapp />
      </div>
    </>
  );
};

export default AppComponents;